export type ParsedField = {
  listFieldKey: string | null;
  rowIndex: number | null;
  fieldKey: string | null;
  fullFieldKey: string;
};

const parseFieldKey = (fullFieldKey: string): ParsedField => {
  const matchFullFieldKey = fullFieldKey.match(/^(.+)\[(\d+)\]\.(.*)/);
  if (matchFullFieldKey) {
    const listFieldKey = matchFullFieldKey[1];
    const rowIndex = matchFullFieldKey[2] ? parseInt(matchFullFieldKey[2], 10) : null;
    const fieldKey = matchFullFieldKey[3];

    return {
      fieldKey,
      fullFieldKey,
      listFieldKey,
      rowIndex,
    };
  }

  const matchRowFieldKey = fullFieldKey.match(/^(.+)\[(\d+)\]$/);
  if (matchRowFieldKey) {
    const listFieldKey = matchRowFieldKey[1];
    const rowIndex = matchRowFieldKey[2] ? parseInt(matchRowFieldKey[2], 10) : null;
    const fieldKey = null;
    return {
      fieldKey,
      fullFieldKey,
      listFieldKey,
      rowIndex,
    };
  }

  return {
    fieldKey: fullFieldKey,
    fullFieldKey,
    listFieldKey: null,
    rowIndex: null,
  };
};

export default parseFieldKey;
